
    import {defineComponent, reactive, ComputedRef, computed, nextTick, onMounted, watch} from 'vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import { Tab, Tabs } from 'scvant';
    import  reportMsgUt from "@/util/reportMsg";

    interface State {
        checkItemsExplain: object[];
        activeName: string;
        reportMsg: object;
        loadedImages: number;
        allImagesLoaded: boolean;
        standardConfig: object;
    }
    export default defineComponent({
        name: "checkStandard",
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        setup() {
            let state: State = reactive({
                activeName: '事故检测',
                checkItemsExplain: [],
                reportMsg: {},
                loadedImages: 0,
                allImagesLoaded: false,
                standardConfig: {
                    accident: {
                        title: '事故检测',
                        code: 'accident',
                        definitionList: [{
                            definitionTitle: '事故车定义：',
                            definition: '经过碰撞、维修不当等外力作用，造成车辆结构件或加强件发生变化，即使修复后但仍存在安全隐患的车辆总称。',
                            standardTitle: '判定标准：',
                            standard: '不可拆水箱框架、导水槽、纵梁连接板等部位存在变形、钣金修复、烧焊等缺陷即认定为C级事故车。\n底大边内侧、底大边外侧、不可拆水箱框架、翼子板内骨架、 后围板、导水槽、车顶、车顶边、后翼子板存在切割；车身底板、行李箱底板、纵梁、减震器座、行李箱后遮物板（铁质）、防火墙、 A/B/C/D 柱内侧及封边、门槛梁存在钣金修复、变形、切割、锈蚀锈透等缺陷认定为D级事故车。',
                        }],
                        standardImg: [
                            {
                                imgTitle: '前排',
                                imgList: [{
                                    imgSrc: 'https://image.268v.com/20220704/png/aca583daf4c58eca3b7b91c040a9abb5.png?x-oss-process=image/resize,l_1000'
                                }
                                ]
                            },
                            {
                                imgTitle: '后排',
                                imgList: [
                                    {
                                        imgSrc: 'https://image.268v.com/20230718/png/52945d2bc751d51ecab90404656c6075.png?x-oss-process=image/resize,l_1000',
                                        imgType: '两厢轿车'
                                    },
                                    {
                                        imgSrc:'https://image.268v.com/20220704/png/bbc24c43f1da80f23ededd5f5ec57219.png?x-oss-process=image/resize,l_1000',
                                        imgType: '三厢轿车'
                                    },
                                    {
                                        imgSrc:'https://image.268v.com/20220704/png/156fee1367c59c3c472a5e11918f2004.png?x-oss-process=image/resize,l_1000',
                                        imgType: 'SUV车型'
                                    }
                                ]   
                            }
                        ]
                    },
                    fire: {
                        title: '火烧检测',
                        code: 'fire',
                        definitionTitle: '火烧车定义：',
                        definition: '车辆经燃烧、炙烤等高温作用，导致车辆部件受损或修复过后存在安全隐患的车辆。',
                        standardTitle: '判定标准：',
                        standard: '减震器座、发动机舱、车身线束、发动机舱内管路、行李箱舱等部位存在烟熏、碳化、受热变形、干粉残留任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车。',
                    },
                    water: {
                        title: '泡水检测',
                        code: 'water',
                        definitionTitle: '泡水车定义：',
                        definition: '因涉水或浸泡导致车舱内进水，并影响车辆电子元件的正常工作，存在安全隐患的车辆。',
                        standardTitle: '判定标准：',
                        standard: '座椅滑轨、安全带、座椅坐垫底部、车顶篷、行李箱、保险丝盒、点烟器底座、转向柱、柱夹层及周边，驾驶室内控制单元等发现有明显的泡水迹象（例如：含泥沙、水印、锈蚀、霉斑等情况）若存在三种或大于三种情况的，即认定为泡水车（因潮湿导致的浮锈除外）。仅主驾地毯（胶）、副驾地毯（胶）、后排地毯（胶）、座椅滑轨、行李箱底板存在相应缺陷，不判定为泡水车，并且主驾地毯（胶）、副驾地毯（胶）、后排地毯（胶）只算作一项但是必须在报告在中注明。',
                    },
                    appearance: {
                        title: '外观检测',
                        code: 'appearance',
                        definitionTitle: '外观检测定义：',
                        definition: '对车辆外观覆盖件检查，覆盖件主要由金属部件、塑料部件以及玻璃部件组成。',
                        standardTitle: '检测标准：',
                        standard: '检测项目中如出现剐蹭、划痕、变形、锈蚀、破损、更换、缝隙不均、拆装痕迹、钣金修复、雹子坑、腻子开裂、喷漆瑕疵、老化、胶体异常、掉（爆）漆、色差、重做漆、脏污、胶体开裂、封边不整、缺失、改装、故障、磨损、碎点、进水、撕裂等缺陷状况，根据《268V检测认定标准》综合判断为外观缺陷。'
                    },
                    appearancePlus: {
                        title: '【加购】外观检测',
                        code: 'appearancePlus',
                        definitionTitle: '加购外观检测标准：',
                        definition: '根据加购检测项中出现钣金修复、变形、拆装痕迹、掉（爆）漆、封边不整、改装、更换、剐蹭、腻子开裂、锈蚀、重做漆、胶体开裂、撕裂等缺陷状况，综合判断为外观缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在上述缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿200元。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                    appearancePlus2503: {
                        title: '【加购】外观检测',
                        code: 'appearancePlus',
                        definitionTitle: '加购外观检测标准：',
                        definition: '根据加购检测项中出现钣金修复、变形、拆装痕迹、更换、剐蹭、腻子开裂、重做漆、破损、碎点等缺陷状况，综合判断为外观缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在《加购服务协议》内对应的承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿，具体赔偿标准详见《加购服务协议》。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                    interior: {
                        title: '内饰检测',
                        code: 'interior',
                        definitionTitle: '内饰检测定义：',
                        definition: '对车辆驾驶室部件检查是否有缺失、磨损以及老化现象。',
                        standardTitle: '检测标准：',
                        standard: '如检测项中出现划痕、脏污、破损、更换、拆装痕迹、缝隙不均、改装、磨损、老化、缺失、烟头烫伤、故障、变形、修复痕迹等缺陷状况，根据《268V检测认定标准》综合判断为内饰缺陷。'
                    },
                    interiorPlus: {
                        title: '【加购】内饰检测',
                        code: 'interiorPlus',
                        definitionTitle: '加购内饰检测标准：',
                        definition: '根据加购检测项中出现改装、破损、缺失、烟头烫伤、脏污等缺陷状况，综合判断为内饰缺陷。 ',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在上述缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿200元。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                    interiorPlus2503: {
                        title: '【加购】内饰检测',
                        code: 'interiorPlus',
                        definitionTitle: '加购内饰检测标准：',
                        definition: '根据加购检测项中出现破损、缺失等缺陷状况，综合判断为内饰缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在《加购服务协议》内对应的承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿，具体赔偿标准详见《加购服务协议》。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                    lightelect: {
                        title: '灯光及电器检测',
                        code: 'lightelect',
                        definitionTitle: '灯光及电器系统检测定义：',
                        definition: '对车辆灯光、电器部件检查是否有破损、故障等现象。',
                        standardTitle: '检测标准：',
                        standard: '如果检测项目中各部件功能出现故障、异响、卡滞问题，根据《268V检测认定标准》综合判断为灯光及电器系统缺陷。 '
                    },
                    power: {
                        title: '动力检测',
                        code: 'power',
                        definitionTitle: '动力检测定义：',
                        definition: '车辆静止状态下检查车辆加速、转向、换挡是否正常。',
                        standardTitle: '检测标准：',
                        standard: '检测标准:如检测项中出现漏油、异响、缸体外部响、缸盖气门响、缸体内部响、故障、冒蓝烟、抖动、渗油、修复痕迹、冒黑烟、油改气、冒白烟、液位高、液位低、变质、破损、老化、漏水、换挡冲击、卡滞、闯挡、拆装痕迹、更换、缺失、改装、水温高等缺陷状况，根据《268V检测认定标准》综合判断为动力缺陷。'
                    },
                    powerPlus: {
                        title: '【加购】动力检测',
                        code: 'powerPlus',
                        definitionTitle: '加购动力检测标准：',
                        definition: '根据加购检测项中出现漏油、漏水、修复痕迹、更换、破损、油改气、拆装痕迹等缺陷状况，综合判断为动力缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在上述缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿200元。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。',
                    },
                    machine: {
                        title: '机舱检测',
                        code: 'machine',
                        definitionTitle: '机舱检测定义：',
                        definition: '车辆静止状态下检查车辆发动机、变速箱等部件是否有破损、漏油、故障等现象。',
                        standardTitle: '检测标准：',
                        standard: '如检测项中出现漏油、渗油、异响、故障、液位高、液位低、变质、破损、老化、漏水、拆装痕迹、更换、改装、脏污、变形等缺陷状况，根据《268V检测认定标准》综合判断为机舱缺陷。'
                    },
                    machinePlus: {
                        title: '【加购】机舱检测',
                        code: 'machinePlus',
                        definitionTitle: '加购机舱检测标准：',
                        definition: '根据加购检测项中出现漏油、漏水、修复痕迹、更换、破损、油改气、拆装痕迹等缺陷状况，综合判断为机舱缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在上述缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿200元。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。',
                    },
                    bottom: {
                        title: '底盘检测',
                        code: 'bottom',
                        definitionTitle: '底盘检测定义：',
                        definition: '检查车辆悬架系统、转向系统以及制动系统等部件是否正常。',
                        standardTitle: '检测标准：',
                        standard: '如检测项中出现划痕、锈蚀、变形、改装、磨损、破损、老化、更换、缺失、沉重、卡滞、漏油、异响、渗油、修复痕迹、故障、拆装痕迹、剐蹭、鼓包等缺陷状况，根据《268V检测认定标准》综合判断为底盘缺陷。'
                    },
                    startup: {
                        title: '启动检测',
                        code: 'startup',
                        definitionTitle: '启动检测定义：',
                        definition: '对车辆启动系统检查是否存在无法启动以及启动困难等现象。',
                        standardTitle: '检测标准：',
                        standard: '如果检测项目中各部件存在故障、启动困难、无法启动等缺陷状况，根据《268V检测认定标准》综合判断为启动缺陷。'
                    },
                    startupPlus: {
                        title: '【加购】启动检测',
                        code: 'startupPlus',
                        definitionTitle: '加购启动检测标准：',
                        definition: '根据加购检测项中出现漏油、漏水、修复痕迹、更换、破损、油改气、拆装痕迹等缺陷状况，综合判断为启动缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在上述缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿200元。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。',
                    },
                    glassPlus: {
                        title: '【加购】玻璃检测',
                        code: 'glassPlus',
                        definitionTitle: '加购玻璃检测标准：',
                        definition: '根据加购检测项中出现划痕、破损、更换、腐蚀性损伤、胶体异常、缺失、改装、故障、碎点、进水等缺陷状况，综合判断为玻璃缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在上述缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿200元。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                    mileageAdjustedPlus2503: {
                        title: '【加购】调表检测',
                        code: 'mileageAdjustedPlus',
                        definitionTitle: '加购调表检测标准：',
                        definition: '车辆表显公里数与历史里程数据或OBD里程读数或车辆综合车况比对，存在异常的，差异大于10000公里（明显录入错误除外），即可判断为车辆存在调表。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在《加购服务协议》内对应的承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿，具体赔偿标准详见《加购服务协议》。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                    engineTransmissionPlus2503: {
                        title: '【加购】发变检测',
                        code: 'engineTransmissionPlus',
                        definitionTitle: '加购发动机、变速器检测标准：',
                        definition: '根据加购检测项中出现漏油、漏水、拆装痕迹、故障等缺陷状况，综合判断为发动机、变速器缺陷。',
                        standardTitle: '加购检测项赔付标准：',
                        standard: '加购检测项存在《加购服务协议》内对应的承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿，具体赔偿标准详见《加购服务协议》。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。'
                    },
                },
            })
            const {query} = useRoute();
            state.activeName = `${query.checkTitle}`;
            state.reportMsg = reportMsgUt;
            let store = useStore();
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            const {checkModuleList} = reportData.value as any;
            let checkItems: any = [];

            let checkCount = checkModuleList.length;
            for (let i=0;i<checkCount;i++){
                let item = checkModuleList[i];
                let version = item.checkStandardVersion || item.styleCode.split('_')[1];
                if (version && state.standardConfig[version]) {
                    checkItems.push(state.standardConfig[version]);
                } else {
                    continue;
                }
            }

            
            let psLocalTitle = '附录';
            let psLocalContent = '事故车、水泡车、火烧车判定标准文件，国家标准GB/T30323-2013《二手车鉴定评估技术规范》，下载链接：https://cyd-prod.oss-cn-zhangjiakou.aliyuncs.com/1c0841d3e8eb92d39f61812ef091621c &#10; 中国汽车流通协会团体标准T/CADA 18-2021《乘用车鉴定评估技术规范》，下载链接：https://cyd-prod.oss-cn-zhangjiakou.aliyuncs.com/2660d2c2d8f13b27d232de0f86514680';
            let ps: ComputedRef<string> = computed<string>(() => (store.state.reportData as any).ps);
            let psTitle: ComputedRef<string> = computed<string>(() => (store.state.reportData as any).psTitle);
            let appendix = {
                title: psTitle.value ? psTitle.value : psLocalTitle,
                code: 'Appendix',
                definition: ps.value ? ps.value : psLocalContent
            }
            checkItems.push(appendix);
            state.checkItemsExplain = checkItems;
            // onMounted(() => {
            //     nextTick(() => {
            //         let el: any = document.getElementById(state.activeName);
            //         let top = el.offsetTop;
            //         // console.log('top:', top);
            //         window.scrollTo(0, top);
            //     });
            // });
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            },
            imageLoaded() {
                this.state.loadedImages++;
                if (this.state.loadedImages === 4) {
                    this.state.allImagesLoaded = true;
                    let el: any = document.getElementById(this.state.activeName);
                    let top = el.offsetTop;
                    // console.log('top:', top);
                    window.scrollTo(0, top);
                }
            },
        }
    })
